
//数据 state
const state = {
    style      : null, // 保存的style
    styleData  : {},     // 保存的style详细数据
    styleArray : [],     // 保存的所有风格数据的数组
  }

  //获取数据 getters
  const getters = {
    StyleMsg      : state => state.style,      // 获取style值
    StyleDataMsg  : state => state.styleData,  // style详细信息
    StyleArrayMsg : state => state.styleArray, // 所有风格数组
  }

  //修改数据 mutations
  const mutations = {
    toggle_StyleDataMsg(state, data) {  // 修改全局style详细数据
      for(let i = 0; i < state.styleArray.length; i++){
        if(state.styleArray[i] && data.id === state.styleArray[i].id){
          state.styleData = state.styleArray[i];
          state.style = state.styleData.id;
          break;
        }
      }
    },
    toggle_StyleArrayMsg(state, data) {  // 修改全局style详细数据
      state.styleArray = data.styleArray;
    },
  }

  export default {
    state,
    getters,
    mutations
  }



// WEBPACK FOOTER //
// ./src/store/modules/style.js